/**
 * <s-metal-trend data-metal="XAU|XAG|XPT|XPD"> shows today's spot change for one metal next to a
 * product price. It does not call the price API itself: s-metal-ticker (header price bar) stores the
 * computed changes on window.gvMetalTrends and announces them with the "gv:metal-trends" event.
 */
const percent = new Intl.NumberFormat('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay: 'exceptZero' });

class MetalTrend extends HTMLElement {
  #onTrends = () => this.#render();

  connectedCallback() {
    window.addEventListener('gv:metal-trends', this.#onTrends);
    this.#render();
  }

  disconnectedCallback() {
    window.removeEventListener('gv:metal-trends', this.#onTrends);
  }

  #render() {
    const pct = window.gvMetalTrends?.[this.dataset.metal ?? ''];
    if (typeof pct !== 'number' || !Number.isFinite(pct)) return;
    const direction = pct > 0 ? 'up' : pct < 0 ? 'down' : 'flat';
    this.classList.toggle('text-price-up', direction === 'up');
    this.classList.toggle('text-price-down', direction === 'down');
    this.classList.toggle('text-on-surface-secondary', direction === 'flat');
    const arrow = this.querySelector('[data-arrow]');
    if (arrow) arrow.textContent = direction === 'up' ? '▲' : direction === 'down' ? '▼' : '■';
    const value = this.querySelector('[data-value]');
    if (value) value.textContent = `${percent.format(pct)} %`;
    this.hidden = false;
  }
}

if (!customElements.get('s-metal-trend')) customElements.define('s-metal-trend', MetalTrend);
